import { ConfiguredSpreadsheets } from 'pages/ValuationsAllocation/hooks';
import { GetSpreadsheetsFromWorkbookParams } from 'pages/ValuationsAllocation/types';
import { getObjectValue, getStringValue } from 'utilities';

const getSpreadsheetsFromWorkbook = (params: GetSpreadsheetsFromWorkbookParams) => {
  const { spreadsheetsNames, workbook } = params;

  const approachSpreadsheets = Object.entries(getObjectValue(workbook)).reduce((accumulator, current) => {
    const [key, spreadsheet] = current;

    if (!(key in spreadsheetsNames)) {
      return accumulator;
    }

    return {
      ...accumulator,
      [getStringValue(spreadsheetsNames[key])]: spreadsheet,
    };
  }, {} as ConfiguredSpreadsheets);

  return approachSpreadsheets;
};

export default getSpreadsheetsFromWorkbook;
